var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCapacitor = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 256 256",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#53B9FF",
  d: "M39.863 54.115.31 93.716l60.995 61.179L0 216.385l39.428 39.62 61.43-61.508 61.097 61.068 39.552-39.602z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#119EFF",
  d: "m140.517 154.896-39.658 39.601 61.097 61.069 39.552-39.602z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.2,
  d: "m140.517 154.896-39.658 39.601 15.267 15.182z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#53B9FF",
  d: "M194.57 100.985 256 39.478 216.43 0l-61.41 61.384L93.917.31 54.365 39.913 216.01 201.761l39.552-39.602z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#119EFF",
  d: "m115.36 100.987 39.659-39.602L93.917.313 54.365 39.914z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.2,
  d: "m115.359 100.985 39.659-39.601-15.27-15.186z"
})));
export default SvgCapacitor;